import { CVStepUploadFileSchema } from 'schemas/cv-steps'

const cVStepUploadFileValidator = CVStepUploadFileSchema

export default cVStepUploadFileValidator
